import React, {PropTypes} from 'react';
import TextInput from '../common/TextInput';

const FileThisRecipe = ({recipe, className, onClick}) => {
	let coverImage = require('../../images/covers/cover_' + recipe.id + '.jpg');
	
	return(
		<div 
			className={className}
			onClick={onClick}
		>
			<div className="file-image"><img src={coverImage} /></div><br />
			<div className="recipe-details">Add This Recipe To:</div>
			<div className="recipe-buttons">
				<div className="recipe-button rose">Indian Recipes</div>
				<div className="recipe-button gold">French Class Recipes</div>
				<div className="recipe-button gold">Recipes with Cumin</div>
				<div className="recipe-button white">Create New Collection</div>
			</div><br />	
			<div>Recommend this recipe to:</div><br />
			<div className="file-recommend">
				<TextInput
					name="userName"
					label="User Name"
					value="" />
			</div>
		</div>
	);
};

FileThisRecipe.propTypes = {
	recipe: PropTypes.object.isRequired,
	className: PropTypes.string,
	onClick: PropTypes.func
};

export default FileThisRecipe;


/** WEBPACK FOOTER **
 ** ./src/components/recipes/FileThisRecipe.js
 **/